import { Link } from "react-router-dom";

interface ArticleCardProps {
  id: number;
  title: string;
  slug: string;
  excerpt: string;
  category: string;
  categoryName: string;
  date: string;
  views: number;
  image: string;
  featured?: boolean;
  size?: "small" | "large";
}

export default function ArticleCard({
  title,
  slug,
  excerpt,
  categoryName,
  category,
  date,
  views,
  image,
  featured,
  size = "small",
}: ArticleCardProps) {
  return (
    <Link
      to={`/article/${slug}`}
      className={`group block bg-background-50 rounded-lg overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all duration-300 ${
        featured ? "lg:col-span-2 lg:grid lg:grid-cols-2" : ""
      }`}
    >
      <div className={`relative overflow-hidden ${size === "large" || featured ? "aspect-[16/9]" : "aspect-[16/9]"}`}>
        <img
          src={image}
          alt={title}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
          title={`51黑料 - ${title}`}
        />
        <div className="absolute top-3 left-3">
          <span className="inline-block px-2.5 py-0.5 text-xs rounded-full bg-primary-500 text-background-50 whitespace-nowrap">
            {categoryName}
          </span>
        </div>
      </div>
      <div className="p-4 md:p-5 flex flex-col justify-between">
        <div>
          <h3 className={`font-sans font-bold text-foreground-900 group-hover:text-primary-500 transition-colors line-clamp-2 ${
            size === "large" || featured ? "text-lg md:text-xl" : "text-base"
          }`}>
            {title}
          </h3>
          <p className="mt-2 text-sm text-foreground-600 leading-relaxed line-clamp-2">
            {excerpt}
          </p>
        </div>
        <div className="mt-3 flex items-center gap-3 text-xs text-foreground-500">
          <span className="flex items-center gap-1">
            <i className="ri-time-line" />
            {date}
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-eye-line" />
            {views >= 10000 ? `${(views / 10000).toFixed(1)}万` : views}
          </span>
        </div>
      </div>
    </Link>
  );
}